import { render, staticRenderFns } from "./ViewIBJJFCompetitors.vue?vue&type=template&id=272031f0"
import script from "./ViewIBJJFCompetitors.vue?vue&type=script&lang=js"
export * from "./ViewIBJJFCompetitors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports